import React from "react";
import { useState, useEffect} from "react";
import Table from "../../../../Components/UiComponents/Table/Table";
import Moment from "react-moment";
import { SOPTableData } from "../../../../JsonData/SOPConfig";
import { getData } from "../../../../Services/Services";
import { getSOPTasksDtlBySOPId } from "../../../../Services/EndPoints";

const SOPTaskTable = (props) => {
  const [rowCount, setRowCount] = useState(0);
  const [SOPData, setSOPData] = useState([]);

  useEffect(() => {
    getSOPTaskDetailList();
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSOPTaskDetailList = async () => {
    var sopTaskList = await getData(
      getSOPTasksDtlBySOPId + props.sopInstanceData.id
    );
    setRowCount(sopTaskList.length);
    setSOPData(sopTaskList);
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Task Name",
        accessor: "task_name",
        disableSortBy: true,
      },

      {
        Header: "Task Description",
        accessor: "description",
        disableSortBy: true,
      },
      {
        Header: "Assigned to Roles",
        disableSortBy: true,
        accessor: "role_name",
      },
      {
        Header: "Created On",
        disableSortBy: true,
        accessor: "created_on",
        Cell: (props) => {
          return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
        },
      },
      {
        Header: "Last Updated On",
        disableSortBy: true,
        accessor: "updated_on",
        Cell: (props) => {
          return <Moment format="DD-MM-YYYY, hh:mm A">{props.value}</Moment>;
        },
      },
    ],
    []
  );
  return (
    <div className="container  create-user">
      <span style={{ color: "#1a7a73", fontSize: "17px", fontWeight: "700px" }}>
        SOP Tasks
      </span>
      <div className="datatable__container">
        {SOPTableData && (
          <Table
            data={SOPData}
            rowCount={rowCount}
            columns={columns}
            numberOfRows={7}
            showExport={false}
            showFilter={false}
            showReset={false}
            onExpand={false}
            headerTableHeadStyle={{ background: "#1a7a73", color: "#FFFFFF" }}
            tableStyle={{ border: "none", padding: "0px", borderRadius: "4px" }}
          />
        )}
      </div>
    </div>
  );
};

export default SOPTaskTable;
